import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import tgiLogo from "../assets/images/logixlog-white.png";
import { useNavigate } from "react-router-dom";

import "../assets/styles/Footer.css";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box component="footer" className="footer-container">
        <Box className="footer-bg" />

        <Grid container spacing={4} className="px-8" justifyContent="center">
          {/* Company Info */}
          <Grid item lg={3} xs={12} md={3}>
            <div className="footer-heading-container">
              <Box
                component="img"
                src={tgiLogo}
                className="tgi-footer"
                alt="LOGIXLOG Logo"
              />
            </div>
            <div className="footer-info-container">
              <Typography variant="body2" className="footer-text">
                At LOGIXLOG, we ensure that we give our customers and clients the
                best when it comes to Website Development, Mobile Application
                Development, and Enterprise Solutions.
              </Typography>
              <Typography variant="body2" className="footer-subtext">
                Working Days: <br />
                <span className="days-name"> Monday - Friday</span>
              </Typography>
            </div>
          </Grid>

          {/* Services */}
          <Grid item lg={3} xs={12} md={3}>
            <div className="footer-heading-container">
              <Typography variant="h6" className="footer-heading">
                Services
              </Typography>
            </div>
            <div className="footer-links-container">
              <Typography variant="body2" className="footer-list-item">
                <a href="#" className="footer-link">
                  Mobile Apps & Solutions
                </a>
              </Typography>
              <Typography
                variant="body2"
                className="footer-list-item"
                sx={{ mt: 1 }}
              >
                <a href="#" className="footer-link">
                  Enterprise Solutions
                </a>
              </Typography>
              <Typography
                variant="body2"
                className="footer-list-item"
                sx={{ mt: 1 }}
              >
                <a href="#" className="footer-link">
                  Website Development
                </a>
              </Typography>
              <Typography
                variant="body2"
                className="footer-list-item"
                sx={{ mt: 1 }}
              >
                <a href="#" className="footer-link">
                  Server Configuration
                </a>
              </Typography>
              <Typography
                variant="body2"
                className="footer-list-item"
                sx={{ mt: 1 }}
              >
                <a href="#" className="footer-link">
                  Testing & QA Services
                </a>
              </Typography>
              <Typography
                variant="body2"
                className="footer-list-item"
                sx={{ mt: 1 }}
              >
                <a href="#" className="footer-link">
                  Social Media Marketing
                </a>
              </Typography>
            </div>
          </Grid>

          {/* Contacts */}
          <Grid item lg={3} xs={12} md={3}>
            <div className="footer-heading-container">
              <Typography variant="h6" className="footer-heading">
                Contacts
              </Typography>
            </div>
            <div className="footer-info-container">
              <Typography variant="body2" className="footer-text-heading">
                Email:<span className="footer-text-span">Sales@logixlog.com</span>
              </Typography>
              <Typography
                variant="body2"
                className="footer-text-heading"
                sx={{ mt: 2 }}
              >
                Phone:{" "}
                <a href="tel:+16179523333" className="footer-link-number">
                  +1 (617) 952 3333
                </a>
              </Typography>
            </div>
          </Grid>

          {/* Newsletter */}
          <Grid item lg={3} xs={12} md={3}>
            <div className="footer-heading-container">
              <Typography variant="h6" className="footer-heading">
                Address
              </Typography>
            </div>
            <div className="footer-info-container">
              <Typography variant="body2" className="footer-text-heading">
                Main Office:{" "}
                <span className="footer-text-span">
                  100 powdermill road, Suit 127, Acton MA 01720 USA
                </span>
              </Typography>
              <Typography variant="body2" className="footer-text-heading">
                Regional Office:
                <span className="footer-text-span">
                  LOGIXLOG, 704-B & 903A, Haly Tower DHA Phase 2, Lahore, Pakistan
                </span>
              </Typography>

              {/* <Typography variant="body2" className="footer-icon">
                <span>
                  <img src="" alt="facebook" />
                </span>
                <span>
                  <img src="" alt="linkdin" />
                </span>
                <span>
                  <img src="" alt="twitter" />
                </span>
              </Typography> */}
            </div>
          </Grid>
        </Grid>
      </Box>
      {/* Footer End Image */}
      <Grid conta></Grid>
      <Box className="footer-end px-8">
        <Typography
          variant="body2"
          className="footer-copyright"
          style={{ textAlign: "center" }}
        >
          Copyright © 2025. All rights reserved.
        </Typography>
        {/* <Typography
          variant="body2"
          className="footer-copyright"
          style={{ textAlign: "center" }}
        >
          <span
            className="mr-4 cursor-pointer"
            onClick={() => navigate("/terms")}
          >
            Terms
          </span>
          <span className="cursor-pointer" onClick={() => navigate("/privacy")}>
            Privacy
          </span>
        </Typography> */}
      </Box>
    </>
  );
};

export default Footer;
